// extracted by mini-css-extract-plugin
module.exports = {"Card":"styles_Card__3lwlX","ResultsCard":"styles_ResultsCard__XhICE","ResultsCardTitle":"styles_ResultsCardTitle__3tIco","ResultsCardIcon":"styles_ResultsCardIcon__2MAL3"};